import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Order } from '../../../models/order.model';
import { OrderService } from '../../../services/order.service';
import { OrderItem } from '../../../models/order-item.model';
import { OrderItemDelivery } from '../../../models/order-item-delivery.model';

@UntilDestroy()
@Component({
  selector: 'app-ship-to-modal',
  templateUrl: './ship-to-modal.component.html',
  styleUrls: ['./ship-to-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ShipToModalComponent implements OnInit {
  attention = '';
  private alive = true;
  inProcess = false;

  order: Order;
  orderItem: OrderItem;
  orderItemDelivery: OrderItemDelivery;
  waitForUpdate = true;

  constructor(
    private orderService: OrderService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.attention = this.orderItemDelivery.deliver_to || '';
  }

  saveShipTo(): void {
    if (this.waitForUpdate) {
      const updatedOrder = new Order(this.order);
      const updatedOrderItem = updatedOrder.createOrderItem(this.orderItem);
      const updateOrderItemDelivery = new OrderItemDelivery(
        this.orderItemDelivery
      );
      updateOrderItemDelivery.deliver_to = this.attention;
      updatedOrderItem.updateDelivery(updateOrderItemDelivery);

      this.inProcess = true;
      this.orderService
        .updateOrderItem(updatedOrder, updatedOrderItem)
        .pipe(untilDestroyed(this))
        .subscribe((data) => {
          this.inProcess = false;
          if (data) {
            this.close({ attention: this.attention });
          }
        });
    } else {
      this.close({ attention: this.attention });
    }
  }

  close(next: any = null) {
    this.activeModal.close(next);
  }
}
